import cookie from 'react-cookie';

const COOKIE_NAME = 'linkedin_landing_job';
// Twine project slugs are alphanumeric + hyphens, e.g. /projects/b9ka00-pickleball-website
const BRIEF_PATH_RE = /^\/projects\/[a-zA-Z0-9-]+$/;
const EXPIRY_HOURS = 24;

/**
 * Freeze the current job page as the LinkedIn landing job.
 * Only saves when the pathname matches the expected brief URL format.
 * @param {string} pathname - e.g. window.location.pathname
 */
export const setLinkedInLandingJob = (pathname) => {
  if (!BRIEF_PATH_RE.test(pathname)) return;
  const expires = new Date();
  expires.setHours(expires.getHours() + EXPIRY_HOURS);
  cookie.save(COOKIE_NAME, pathname, { path: '/', expires });
};

/**
 * Return the frozen landing-job path, or null if not set.
 * @returns {string|null}
 */
export const getLinkedInLandingJob = () => cookie.load(COOKIE_NAME) || null;

/**
 * Return true when the current page is the LinkedIn landing job.
 *
 * Only new users who signed up via the LinkedIn link will ever have the
 * linkedin_landing_job cookie — it is written exclusively in
 * BriefDetailsOnboarding.handleCreateAccount at the moment of signup.
 * Existing users who already had an account before this feature shipped
 * will never have the cookie and therefore never get the bypass.
 *
 * @returns {boolean}
 */
export const isLinkedInLandingJob = () => {
  const landingJob = getLinkedInLandingJob();
  return !!landingJob && landingJob === window.location.pathname;
};
